import { Component, inject, Input } from '@angular/core';
import { ScreeningBriefResponseDto } from '../../../../common/general-types/social-screening.dto';
import { Router } from '@angular/router';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';

@Component({
  selector: 'sb-kanban-card',
  standalone: true,
  imports: [],
  templateUrl: './kanban-card.component.html',
  styleUrl: './kanban-card.component.css'
})
export class KanbanCardComponent {

  @Input() brief!: ScreeningBriefResponseDto;

  /** Services */
  private router = inject(Router);
  private socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  formatDate(date: Date | string | undefined): string {
    if (!date) {
      return 'N/A';
    }

    const dateObj = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dateObj.getTime())) {
      return 'Invalid date';
    }

    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(dateObj);
  }

  viewResults() {
    this.socialScreeningService.focussedScreeningBriefSignal.set(this.brief);
    this.router.navigate(['/screening-brief-results', this.brief.id]);
  }

  selectCreatorList() {
    // The drawer is page-level, so tell it which brief it is attaching a group to.
    this.socialScreeningService.focussedScreeningBriefSignal.set(this.brief);
    this.socialScreeningService.showSelectCreatorList.set(true);
  }

}
